<template>
  <div>
    <div class="tab-inner-form">
      <div></div>
      <div>
        <el-input
          v-model="config.vendorName"
          clearable
          style="width: 240px;margin-left: 10px"
          placeholder="请输入商家名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </div>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="商家名称"
        min-width="120"
        prop="vendorName"></el-table-column>
      <el-table-column
        label="鉴定意见书申请数量"
        width="100"
        prop="certApplyCount"></el-table-column>
      <el-table-column
        label="鉴定意见书发放数量"
        width="100"
        prop="certProvideCount"></el-table-column>
      <el-table-column
        label="鉴定意见书使用数量"
        width="100"
        prop="certUsedCount"></el-table-column>
      <el-table-column
        label="鉴定意见书剩余数量"
        width="100"
        prop="certRemainCount"></el-table-column>
      <el-table-column
        label="商家防伪扣申请数量"
        width="100"
        prop="tagApplyCount"></el-table-column>
      <el-table-column
        label="商家防伪扣发放数量"
        width="100"
        prop="tagProvideCount"></el-table-column>
      <el-table-column
        label="商家防伪扣使用数量"
        width="100"
        prop="tagUsedCount"></el-table-column>
      <el-table-column
        label="商家防伪扣剩余数量"
        width="100"
        prop="tagRemainCount"></el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      background
      style="text-align:center"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'VendorUsedTable',
  components: { },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, vendorName: '' }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('appraise/getappraisaltaguseds', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
